import { render, staticRenderFns } from "./tripartite.vue?vue&type=template&id=26c4f13b&scoped=true&"
import script from "./tripartite.vue?vue&type=script&lang=ts&"
export * from "./tripartite.vue?vue&type=script&lang=ts&"
import style0 from "./tripartite.vue?vue&type=style&index=0&id=26c4f13b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c4f13b",
  null
  
)

export default component.exports